import { useState } from "react";
import Sidebar from "../../components/common/Sidebar";
import Navbar from "../../components/common/Navbar";
import { createStaffApi, deactivateUserApi } from "../../services/authApi";
import "./Staff.css";

const StaffManagement = () => {

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: ""
  });

  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);

  // handle input
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // CREATE STAFF
  const handleCreate = async () => {
    try {
      setLoading(true);

      const res = await createStaffApi(form);

      alert("✅ Staff created");

      setStaffList((prev) => [...prev, res.data.user]);

      setForm({ name: "", email: "", password: "" });

    } catch (err) {
      alert(err?.response?.data?.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  // DEACTIVATE
  const handleDeactivate = async (id) => {
    try {
      await deactivateUserApi(id);

      alert("🚫 User deactivated");

      setStaffList((prev) =>
        prev.map((u) =>
          u.id === id ? { ...u, is_active: false } : u
        )
      );

    } catch (err) {
      alert("Error");
    }
  };

  return (
    <div className="admin-container">

      <Sidebar role="admin" />

      <div className="admin-main">

        <Navbar />

        <div className="admin-content">

          <h2>👨‍💼 Staff Management</h2>

          {/* ===== CREATE STAFF ===== */}
          <div className="staff-box">
            <h3>Create Staff</h3>

            <div className="staff-form">
              <input
                name="name"
                placeholder="Name"
                value={form.name}
                onChange={handleChange}
              />

              <input
                name="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
              />

              <input
                name="password"
                placeholder="Password"
                type="password"
                value={form.password}
                onChange={handleChange}
              />

              <button onClick={handleCreate} disabled={loading}>
                ➕ Create
              </button>
            </div>
          </div>

          {/* ===== STAFF LIST ===== */}
          <div className="staff-box">
            <h3>Staff List</h3>

            <table className="staff-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {staffList.map((user) => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>
                      {user.is_active ? "🟢 Active" : "🔴 Inactive"}
                    </td>
                    <td>
                      {user.is_active && (
                        <button
                          onClick={() => handleDeactivate(user.id)}
                        >
                          Deactivate
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

          </div>

        </div>
      </div>
    </div>
  );
};

export default StaffManagement;